import React,{ useState } from "react";
import {CopyToClipboard} from "react-copy-to-clipboard";
import {  Modal } from "react-bootstrap";
import {   StyledBlueButton  } from "../../styles/BootstrapStyles";
import _ from "lodash";
import "../../styles/form.scss";
import "../../styles/summary.scss";
import { useStyles } from "../modal/Modal.styles";
import SummaryUtils from "../../utils/SummaryUtils";
import { List, ListItem, Snackbar } from "@material-ui/core";
import MuiAlert from "@material-ui/lab/Alert";

const FilesModal=({show,files,onClose})=>{
  const [copy,setCopy] = useState(false);
  const classes = useStyles();

  const getFiles = () => {
    const filesArray = SummaryUtils.transformFilesCount(files);
    const list = _.map(filesArray,(obj,index) => {
      const listOfFiles = _.map(obj.files,(file,index) => {
        return (
          <List key={index} disablePadding>
            <ListItem classes={{ root: classes.listItem }}>
                <CopyToClipboard text={file} onCopy={() => {setCopy(true)}}>
                  <span className="copyFileSpan">{file}</span>
                </CopyToClipboard>
            </ListItem>
          </List>
        );
      })
      return (
       <List key={index} disablePadding>
         <ListItem className={classes.extensionList}>
           <span className="extensionSpan">{_.size(obj.files) > 1 ? `${obj.extension} (${_.size(obj.files)})` : obj.extension}</span>
        </ListItem>
        {listOfFiles}
       </List>
      );
    })
    return <div className={classes.filesList}>{list}</div>;
  }
    return (
        <div>
            <Modal
                className="modal warning-modal"
                show={show}
                dialogClassName="modalDialog"
            >
                <Modal.Header className="modalHeader">
                    <Modal.Title className="modalHeaderTitle">Files</Modal.Title>
                </Modal.Header>
                <Modal.Body className={classes.fileModalBody}>
                    {getFiles()}
                </Modal.Body>
                <Modal.Footer className={classes.fileModalFooter}>
                    <StyledBlueButton
                        onClick={onClose}>
                        OK
                    </StyledBlueButton>
                </Modal.Footer>
            </Modal>
            <Snackbar
                onClose={() => {
                    setCopy(false);
                }}
                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                open={copy}
                autoHideDuration={1000}
            >
                <MuiAlert elevation={6} variant="filled"
                    onClose={() => {
                        setCopy(false);
                    }}
                    severity="success">
                    Copied to Clipboard
                </MuiAlert>
            </Snackbar>
        </div>
    )
}

FilesModal.defaultProps={
    show:false,
    files:[],
    onClose:()=>{/*default Prop*/}
}

export default FilesModal;